import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the FollowersFollowingCount component.
 */
const useFollowersFollowingCountStyles = makeStyles()(() => ({
  followerFollowingCountEntry: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.gap.xs,
  },
  followerFollowingCount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.gap.xl,
    borderRadius: theme.borderRadius.s,
    padding: `${theme.padding.m} ${theme.padding.xl}`,
    boxShadow: `2px 2px 5px 5px ${colors.gray['200']}`,
  },
  followerFollowingText: {
    color: theme.primary.light,
  },
  clickable: {
    cursor: 'pointer',
  },
  clickableText: {
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
}));

export default useFollowersFollowingCountStyles;
